import { setContext } from "@apollo/link-context";
import { ApolloLink, HttpLink } from "@apollo/client";
import { Auth } from "aws-amplify";

export const createAppSyncHttpLink = function ({ appSyncApiUrl, getJwtToken }) {
  // const authorizationHeaderLink = setContext(
  //   async (request, previousContext) => ({
  //     ...previousContext,
  //     headers: {
  //       ...previousContext.headers,
  //       Authorization: await getJwtToken()
  //     }
  //   })
  // );
  const authorizationHeaderLink = setContext(async (request, { headers }) => {
    try {
      const token = await getJwtToken();
      // return the headers to the context so httpLink can read them
      return {
        headers: {
          ...headers,
          authorization: token ? token : ""
        }
      };
    } catch (error) {
      console.log("Auth Error", error);
      Auth.signOut({ global: true }).then(() => {
        window.location.href = "/";
      });
    }
  });

  return ApolloLink.concat(
    authorizationHeaderLink,
    new HttpLink({ uri: appSyncApiUrl })
  );
};
